(function () {
  /**
   * Transforms [text] into <span class="special_char">text</span>
   */
  function applyFlourish(container) {
    const targets = container.querySelectorAll("[data-flourish]");
    targets.forEach((el) => {
      const rawText = el.getAttribute('data-raw-text') || el.textContent;
      if (!el.getAttribute('data-raw-text')) {
        el.setAttribute('data-raw-text', rawText); 
      }
      
      if (rawText.includes("[") && rawText.includes("]")) {
        el.innerHTML = rawText.replace(
          /\[(.*?)\]/g,
          '<span class="special_char">$1</span>'
        );
      }
    });
  }

  function initHeroSlider(section) {
    if (!section || typeof Swiper === "undefined") return;

    const id = section.getAttribute("data-section-id");
    const mainEl = section.querySelector(".hero-slider--" + id);
    const overlayEl = section.querySelector(".hero-slider-overlay--" + id);
    const paginationEl = section.querySelector(".hero-slider__pagination--" + id);
    const innerWrap = section.querySelector(".hero-slider__inner");


    if (!mainEl || !overlayEl) return;

    applyFlourish(section);

    // --- Dynamic Theme Function ---
    const updateTheme = (swiper) => {
      if (!innerWrap) return;
      // In loop mode, we grab the active slide
      const activeSlide = swiper.slides[swiper.activeIndex];
      if (!activeSlide) return;

      const bgColor = activeSlide.getAttribute('data-slide-bg') ?? 'var(--welljoy-sand';
      const textColor = activeSlide.getAttribute('data-text-col') ?? '#000000'

      if (bgColor) {
        innerWrap.style.setProperty('--dynamic-inner-bg', bgColor);
      } 

      if (overlayEl) {
        overlayEl.style.setProperty('--foot-text-color', textColor);
      }
    };

    const mainSwiper = new Swiper(mainEl, {
      autoHeight: false,
      loop: true,
      speed: 800,
      effect: "fade",
      fadeEffect: { crossFade: true },
      allowTouchMove: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      on: {
        init: function() {
          updateTheme(this);
        },
        slideChange: function() {
          updateTheme(this);
        },
        autoplayTimeLeft(swiper, time, progress) {
          const activeBullet = document.querySelector(
            ".hero-slider__overlay .swiper-pagination-bullet.swiper-pagination-bullet-active"
          );

          if (activeBullet) {
            const percent = (1 - progress) * 100;
            activeBullet.style.setProperty("--progress", `${percent}%`);
          }
        }
      }
    });

    const overlaySwiper = new Swiper(overlayEl, {
      loop: true,
      speed: 800,
      effect: "fade",
      fadeEffect: { crossFade: true },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
    });

    // Sync Swipers
    mainSwiper.controller.control = overlaySwiper;
    overlaySwiper.controller.control = mainSwiper;

    // Slide on click (excluding links/buttons)
    mainEl.addEventListener("click", function (e) {
      if (e.target.closest("a, button, .swiper-pagination")) return;
      mainSwiper.slideNext();
    });

    // Shopify Editor Events
    document.addEventListener("shopify:block:select", (evt) => {
      const blockSlide = evt.target.closest('.swiper-slide');
      if (blockSlide) {
        // Since it's a loop, we find the real index
        const index = parseInt(blockSlide.getAttribute('data-swiper-slide-index'));
        if (!isNaN(index)) {
          mainSwiper.slideToLoop(index);
        }
        applyFlourish(section);
      }
    });
  }

  function mount() {
    document.querySelectorAll(".hero-slider-section").forEach(initHeroSlider);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mount);
  } else {
    mount();
  }

  document.addEventListener("shopify:section:load", (evt) => {
    const section = document.getElementById("HeroSlider-" + evt.detail.sectionId);
    if (section) initHeroSlider(section);
  });
})();